import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CFormGroup,
  CLabel,
  CSpinner,
  CSelect,
  CInputGroupText,
  CInputGroupPrepend,
  CInputGroup
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom";
import { bindActionCreators } from "redux";

import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class RoomCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      loading: false,
      room: null,
      creating: false,
      optionsGroup: [{ value: null, name: "Carregando" }],
      optionsRegion: [{ value: null, name: "Carregando" }],
      optionsSchool: [{ value: null, name: "Carregando" }],
      group_id: null,
      region_id: null,
      school_id: null
    };

    this.formRef = React.createRef();
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    axios
      .get(`${URL.api}access/group/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respGroup => {
          const optionsGroup = [];
          respGroup.data.data.forEach(group => {
            optionsGroup.push({ value: group.id, name: group.name });
          });

          this.setState({ optionsGroup });
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    axios
      .get(`${URL.api}access/region/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respRegion => {
          const optionsRegion = [];
          respRegion.data.data.forEach(region => {
            optionsRegion.push({
              value: region.id,
              name: region.name,
              group_id: region.group_id
            });
          });

          this.setState({ optionsRegion });
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    axios
      .get(`${URL.api}access/school/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respSchool => {
          const optionsSchool = [];
          respSchool.data.data.forEach(school => {
            optionsSchool.push({
              value: school.id,
              name: school.name,
              region_id: school.region_id
            });
          });

          this.setState({ optionsSchool });
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    const { id } = this.props.match.params;

    if (id) {
      this.setState(
        () => ({ loading: true }),
        () => {
          axios
            .get(`${URL.api}community/room/singleView/${id}`, {
              headers: { Authorization: `Bearer ${this.props.user.token}` }
            })
            .then(resp => {
              if (resp.data.success) {
                this.setState(
                  () => ({
                    room: resp.data.data.room,
                    group_id: resp.data.data.room.group_id,
                    region_id: resp.data.data.room.region_id,
                    school_id: resp.data.data.room.school_id
                  }),
                  () => {
                    this.setState(() => ({
                      edit: true,
                      loading: false
                    }));
                  }
                );
              }
            });
        }
      );
    } else {
      this.setState({
        group_id: this.props.general.active_roles.group_id,
        region_id: this.props.general.active_roles.region_id,
        school_id: this.props.general.active_roles.school_id
      });
    }
  }

  error(response) {
    toastr.error("Falha", response);
  }

  enviar(value) {
    this.setState({ creating: true });

    const obj = {
      loggedUser: this.props.user.user.id,
      name: value.name,
      type: value.type,
      group_id: this.state.group_id,
      region_id: this.state.region_id,
      school_id: this.state.school_id,
      class: false
    };

    axios
      .post(`${URL.api}community/room/insert`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.props.history.push("/room/list");
          this.setState({ creating: false });
        },
        () => {
          this.error("Não foi possível criar a turma");
          this.setState({ creating: false });
        }
      );
  }

  atualizar(value) {
    this.setState({ creating: true });

    const obj = {
      loggedUser: this.props.user.user.id,
      name: value.name,
      type: value.type,
      group_id: this.state.group_id,
      region_id: this.state.region_id,
      school_id: this.state.school_id,
      class: false
    };

    axios
      .post(`${URL.api}community/room/update/${value.id}`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.props.history.push("/room/list");
          this.setState({ creating: false });
        },
        () => {
          this.error("Não foi possível editar a turma");
          this.setState({ creating: false });
        }
      );
  }

  onCloseModal(selected = null) {
    if (selected !== null) {
      // eslint-disable-next-line react/no-unused-state
      this.setState({ selectedUsers: selected });
    }

    // eslint-disable-next-line react/no-unused-state
    this.setState({ usersModal: false });
  }

  render() {
    const fields = [
      {
        name: "name",
        label: "Nome",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      },
      {
        name: "type",
        label: "Tipo",
        type: "select",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        options: [
          { value: "open", name: "Aberta" },
          { value: "semi", name: "Semi-aberta" },
          { value: "closed", name: "Fechada" }
        ],
        validate: [required]
      }
    ];

    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/room/list", to: "/room/list" }]}
        />
        <Prompt
          when={!this.state.creating}
          message="Os dados do formulário ainda não foram salvos. Tem certeza de que deseja sair desta página?"
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar Comunidade" : "Criar Comunidade"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite a comunidade selecionada"
                    : "Crie uma nova comunidade"}
                </div>
              </div>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() => this.formRef.current.submit()}
                disabled={this.state.creating}
              >
                <>
                  <span style={this.state.creating ? { opacity: 0 } : null}>
                    <i className="fa fa-cloud-upload mr-2"></i>Salvar
                  </span>
                  {this.state.creating && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CCardHeader>
            <CCardBody>
              <Form
                avatar
                fields={fields}
                back={false}
                history={this.props.history}
                ref={this.formRef}
                onSubmit={this.state.edit ? this.atualizar : this.enviar}
                initialValues={this.state.room}
                edit={this.state.edit}
              />
              <CFormGroup>
                <CLabel>Grupo</CLabel>
                <CInputGroup>
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-group"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    className="flex-1"
                    value={this.state.group_id}
                    onChange={e =>
                      this.setState({
                        group_id: parseInt(e.target.value),
                        region_id: null,
                        school_id: null
                      })
                    }
                    disabled={this.props.general.active_roles.group_id !== null}
                  >
                    <option value={null}>Grupo</option>
                    {this.state.optionsGroup.map(group => (
                      <option value={group.value}>{group.name}</option>
                    ))}
                  </CSelect>
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>Regional</CLabel>
                <CInputGroup>
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-group"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    className="flex-1"
                    value={this.state.region_id}
                    onChange={e =>
                      this.setState({
                        region_id: parseInt(e.target.value),
                        school_id: null
                      })
                    }
                    disabled={
                      this.props.general.active_roles.region_id !== null
                    }
                  >
                    <option value={null}>Regional</option>
                    {this.state.optionsRegion
                      .filter(region => region.group_id === this.state.group_id)
                      .map(region => (
                        <option value={region.value}>{region.name}</option>
                      ))}
                  </CSelect>
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>Escola</CLabel>
                <CInputGroup>
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-group"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    className="flex-1"
                    value={this.state.school_id}
                    onChange={e =>
                      this.setState({ school_id: parseInt(e.target.value) })
                    }
                    disabled={
                      this.props.general.active_roles.school_id !== null
                    }
                  >
                    <option value={null}>Escola</option>
                    {this.state.optionsSchool
                      .filter(
                        school => school.region_id === this.state.region_id
                      )
                      .map(school => (
                        <option value={school.value}>{school.name}</option>
                      ))}
                  </CSelect>
                </CInputGroup>
              </CFormGroup>
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setObj }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(RoomCreate);
